module.exports = __webpack_public_path__ + "img/inger.95e11e08.jpg";